import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenMessageService } from '../../report/services/screen-message.service';
import type { ScreenMessageSeverity } from '../../report/config/screen-message.types';

/** 長文を1行で省略する閾値（文字数） */
const TRUNCATE_THRESHOLD = 80;

@Component({
  selector: 'app-screen-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './screen-message.component.html',
  styleUrl: './screen-message.component.scss',
})
export class ScreenMessageComponent {
  private screenMessageService = inject(ScreenMessageService);

  /** 詳細展開の有無（セッション内のみ） */
  expanded = signal(false);
  /** 閉じたか（セッション内のみ非表示） */
  dismissed = signal(false);

  readonly firstMessage = this.screenMessageService.firstMessage;
  readonly restCount = this.screenMessageService.restCount;

  /** 省略表示用：閾値超えなら短く切る */
  truncate(text: string, threshold: number = TRUNCATE_THRESHOLD): string {
    if (!text || text.length <= threshold) return text;
    return text.slice(0, threshold) + '…';
  }

  /** 詳細トグル */
  toggleExpand(): void {
    this.expanded.update((v) => !v);
  }

  /** 閉じる（セッション中のみ非表示） */
  dismiss(): void {
    this.dismissed.set(true);
  }

  /** severity に応じた CSS クラス */
  severityClass(severity?: ScreenMessageSeverity): string {
    switch (severity) {
      case 'info':
        return 'screen-message--info';
      case 'error':
        return 'screen-message--error';
      case 'warn':
      default:
        return 'screen-message--warn';
    }
  }
}
